import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import CodeTab from '../../modules/code/CodeTab';




const Code = (props) => {

    const [activeTab, setActiveTab] = useState('CODE');
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('general.label.codeList')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('general.label.codeList')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('general.label.codeList')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'CODE'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('CODE')
                                                    }
                                                >
                                                    {t('general.label.codeList')}
                                                </button>
                                            </li>                                           
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <CodeTab
                                                isActive={activeTab === 'CODE'}                                               
                                            />                                                                                                                                                                          
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Code;